<div class="modal-container" #dialog>
  <div class="cx-dialog-header modal-header">
    <button type="button" class="close" (click)="dismissModal('Cross click')">
      <span aria-hidden="true">
        <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
      </span>
    </button>
  </div>
  <div class="cx-dialog-body modal-body">
    <div class="img-container">
      <img src="{{ imageURL }}" alt="" />
    </div>
  </div>
</div>
